// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';
import DatePicker from 'react-datepicker';
import Icon from 'shared/components/Icon';

class ExampleCustomInput extends React.Component {
  render() {
    return (
      <p className="control has-icons-left">
        <input
          name={this.props.name}
          className="input bulma__input"
          type="text"
          placeholder="mm/dd/yyyy"
          onClick={this.props.onClick}
          value={this.props.value}
          onChange={this.props.onChange}
        />
        <span className="icon is-small is-left">
          <Icon name="calendar" />
        </span>
      </p>
    );
  }
}

ExampleCustomInput.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
};

// Specifically exclude `onBlur`, since it doesn't work well with DatePicker
// Also translate `moment` dates into strings on the way out and from strings into `moment` dates
// in the way in
const RawDatePicker = ({ value, onBlur, onChange, meta, ...rest }) => {
  const showError = meta && meta.touched && meta.error;

  return (
    <div className="field">
      <DatePicker
        {...rest}
        customInput={<ExampleCustomInput />}
        selected={value}
        onChange={onChange}
      />
      {showError && (
        <p className="help has-text-left is-danger">{meta.error}</p>
      )}
    </div>
  );
};

RawDatePicker.displayName = 'RawDatePicker';

const DatePickerInput = connectFormComponentToReduxForm(RawDatePicker);
DatePickerInput.displayName = 'DatePickerInput';

export default DatePickerInput;
